const imageCache = new Map();
const fetchCache = new Map();
const MAX_CACHE_SIZE = 100;

function clearId8ImageCaches() {
  for (const url of imageCache.values()) {
    URL.revokeObjectURL(url);
  }
  imageCache.clear();
  fetchCache.clear();
}

function setInCache(cache, key, value) {
  if (cache.size >= MAX_CACHE_SIZE) {
    const firstKey = cache.keys().next().value;
    const url = imageCache.get(firstKey);
    if (url) URL.revokeObjectURL(url);
    cache.delete(firstKey);
  }
  cache.set(key, value);
}

export { clearId8ImageCaches, setInCache, imageCache, fetchCache };
